import { render, staticRenderFns } from "./ProdutoFracionado.vue?vue&type=template&id=14c16cf5"
import script from "./ProdutoFracionado.vue?vue&type=script&lang=js"
export * from "./ProdutoFracionado.vue?vue&type=script&lang=js"
import style0 from "./ProdutoFracionado.vue?vue&type=style&index=0&id=14c16cf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports